import { FC, ReactElement } from 'react'

import { ListGroupItem, MaterialIcon } from '@/components'

import './ProfileListItem.scss'

interface ProfileListItemProps {
    title: string
    values?: (string | number | null | undefined)[]
    onClick?: (title: string) => void
}

export const ProfileListItem: FC<ProfileListItemProps> = ({
    title,
    values = [],
    onClick,
}): ReactElement => {
    const onListGroupItemClick = (): void => {
        onClick?.(title)
    }

    return (
        <ListGroupItem
            onClick={onClick && onListGroupItemClick}
            className="profile-list-item"
        >
            <div className="profile-list-item__header list-group-item__header">
                { title }
            </div>
            { values.length > 0 && (
                <div className="profile-list-item__values">
                    { values.map((value, index) => (
                        <div key={`value-${index + 1}`} className="profile-list-item__value">
                            { value || '' }
                        </div>
                    ))}
                </div>
            )}
            { onClick && (
                <MaterialIcon
                    className="profile-list-item__icon"
                    color="orange"
                    fontSize={24}
                    kind="create"
                />
            )}
        </ListGroupItem>
    )
}
